// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { Provider } from 'react-redux'

// Components
import SortingSelect from 'store/modules/product/components/SortingSelect'
import Themed from 'store/v2/react/components/Themed'

// Shared

const store = window.booqableStore

export default class SortingSelectContainer extends Component {
  static displayName = 'SortingSelectContainer'

  static propTypes = {
    filterKey: PropTypes.string
  }

  static defaultProps = {
    filterKey: 'global'
  }

  render () {
    const { filterKey } = this.props

    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <SortingSelect filterKey={filterKey} />
          </div>
        </Themed>
      </Provider>
    )
  }
}
